/**
 * Title Service
 * Job Titles and Relationship Types
 */

import api from '../lib/api';

export const titleService = {
  // ============================================================================
  // JOB TITLES
  // ============================================================================
  
  async getJobTitles(includeInactive = false) {
    const response = await api.get('/titles/job-titles', {
      params: { includeInactive: includeInactive ? 'true' : undefined }
    });
    return response.data;
  },

  async createJobTitle(data) {
    const response = await api.post('/titles/job-titles', data);
    return response.data;
  },

  async updateJobTitle(id, data) {
    const response = await api.put(`/titles/job-titles/${id}`, data);
    return response.data;
  },

  async deleteJobTitle(id) {
    const response = await api.delete(`/titles/job-titles/${id}`);
    return response.data;
  },

  async reorderJobTitles(orderedIds) {
    const response = await api.post('/titles/job-titles/reorder', { orderedIds });
    return response.data;
  },

  async seedDefaultJobTitles() {
    const response = await api.post('/titles/job-titles/seed');
    return response.data;
  },

  // ============================================================================
  // RELATIONSHIP TYPES
  // ============================================================================
  
  async getRelationshipTypes(includeInactive = false) {
    const response = await api.get('/titles/relationship-types', {
      params: { includeInactive: includeInactive ? 'true' : undefined }
    });
    return response.data;
  },

  async createRelationshipType(data) {
    const response = await api.post('/titles/relationship-types', data);
    return response.data;
  },

  async updateRelationshipType(id, data) {
    const response = await api.put(`/titles/relationship-types/${id}`, data);
    return response.data;
  },

  async deleteRelationshipType(id) {
    const response = await api.delete(`/titles/relationship-types/${id}`);
    return response.data;
  },

  async reorderRelationshipTypes(orderedIds) {
    const response = await api.post('/titles/relationship-types/reorder', { orderedIds });
    return response.data;
  },

  async seedDefaultRelationshipTypes() {
    const response = await api.post('/titles/relationship-types/seed');
    return response.data;
  },
};
